'use client';

export { useUserIdentityChange } from '@/hooks/useUserIdentityChange';
